module.exports = __webpack_public_path__ + "img/blog-other-articles-img-2.6cb97b19.png";